export class Role {
  id: number;
  name: string;
  weight: number;
  description: string;
}